/**
 * Created by Florin David on 04/01/2017.
 */
import version from 'lib/version'

/**
 *
 * @param {String} state
 *
 * @return {String}
 */
export default (state = version): string => {
  return state
}
